import { get, post } from 'utils/methods';

export function getPackagingApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}order-items`, data, headers);
}

export function getOverviewApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}order-items/overview`, data, headers);
}

export function closeOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/close-order-item`, data, headers);
}
